// extracted by mini-css-extract-plugin
export default {"eventLogs":"EventLogs_eventLogs__oPXwY","header":"EventLogs_header__CsCvF","title":"EventLogs_title__Lk43d"};